module.exports = __webpack_public_path__ + "img/122_speed-skating.b1581cf8.jpg";